var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompassRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M21.851 1.071c.656.55-.944 6.082-3.097 11.56l-.278.698c-1.496 3.72-3.215 7.315-4.62 9.196a1.51 1.51 0 01-.164.192l-.094.085c-.487.398-.988.181-.887-.521.28-1.912.09-4.596-.522-6.417-.26-.782-.599-1.403-1.01-1.74-.383-.312-1.021-.501-1.8-.586-1.917-.218-4.684.188-6.575.879-.79.293-1.087-.383-.482-1.068.17-.192.357-.393.563-.598C7.482 8.118 20.765.165 21.85 1.07zM9.377 13.541c.778.085 1.417.274 1.8.586.41.337.749.958 1.009 1.74-1.66.81-2.843 1.21-3.135.964-.293-.245-.135-1.49.326-3.29z"
  }))));
}

export default SvgCompassRocket;